import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl, useIntl } from 'react-intl';

import { showConfirmationModal } from '../actions/App';
import { fetchUserProfile } from '../actions/Auth';

import { APIupdateUserSettings } from '../api/User';

import {
  getSetting,
  getUserSetting,
} from '../helpers/Settings';

const ViewModeSwitch = ({ profile, handleSwitchMode }) => {
  const intl = useIntl();

  if (
    !profile.is_admin ||
    getSetting('cs1') ||
    !getUserSetting('view_mode_switcher') ||
    profile.is_superadmin
  ) {
    return null;
  }

  const viewMode = getUserSetting('view_mode');

  return (
    <>
      <NavLink
        href="#switch-mode"
        id="switch-mode-icon"
        onClick={(e) => {
          e.preventDefault();
          handleSwitchMode(profile.uuid, viewMode === 'admin' ? 'user' : 'admin', () => {
            window.location = '/';
          });
        }}
        aria-label={intl.formatMessage({ defaultMessage: 'Switch view mode' })}
      >
        {viewMode === 'admin' && (
          <i className="far fa-globe" />
        )}
        {viewMode === 'user' && (
          <i className="far fa-user" />
        )}
      </NavLink>
      <UncontrolledTooltip fade={false} placement="bottom" target="switch-mode-icon">
        {viewMode === 'admin' && (
          intl.formatMessage({ defaultMessage: 'View all users\' files and Collections' })
        )}
        {viewMode === 'user' && (
          intl.formatMessage({ defaultMessage: 'View only your files and Collections + those you have access to' })
        )}
      </UncontrolledTooltip>
    </>
  );
};

const mapDispatchToProps = (dispatch, props) => ({
  handleSwitchMode: (userUuid, mode, callback) => {
    const { intl } = props;
    const text =
      mode === 'admin' ?
        intl.formatMessage({
          defaultMessage: `Are you sure you want to switch to global admin mode?
          You will see all your users files and Collections. You can switch modes at any time.`,
        })
        :
        intl.formatMessage({
          defaultMessage: `Are you sure you want to switch to admin mode?
          You will see only files and Collections that you have uploaded, created, or been given access to.
          You can switch to global admin at any time.`,
        });
    const modalParams = {
      title: mode === 'admin' ?
        intl.formatMessage({ defaultMessage: 'Switch to global admin?' }) :
        intl.formatMessage({ defaultMessage: 'Switch to admin?' }),
      text,
      onConfirm: () => (
        APIupdateUserSettings(userUuid, { view_mode: mode }).then(() => {
          dispatch(fetchUserProfile()).then(() => {
            callback();
          });
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

ViewModeSwitch.propTypes = {
  profile: PropTypes.object.isRequired,
  handleSwitchMode: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ViewModeSwitch)));
